
(() => {
  const solaris = $(".prism-solaris.v_hoverWrap");
  const solarisPro = $(".prism-solaris-pro.v_hoverWrap");

  function addSizeSelectors() {
    // solaris
    const colorlist_solaris = solaris.find(".colorlist").first();
    const template_solaris = `
    <ul class="collection variantlist colorlist active">
      <li class="variant-item">
        <span
          class="variant-color solaris-size selected"
          data-size="standard"
          data-title="1.0m Rack"
          data-image_1="https://prismplus.sg/cdn/shop/files/Solaris_Standard_1.0m_Pearl_White__01_1024x1024@2x.jpg?v=1772294246"
          data-image_2="https://prismplus.sg/cdn/shop/files/Solaris_Standard_1.0m_Space_Grey__01_1024x1024@2x.jpg?v=1770782181"
          data-url_1="/products/prism-solaris?variant=47432030421219"
          data-url_2="/products/prism-solaris?variant=47432032157923"
          data-price="$469.00"
        >
          1.0m
        </span>
      </li>
      <li class="variant-item">
        <span
          class="variant-color solaris-size"
          data-size="xl"
          data-title="1.3m Rack"
          data-image_1="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_XL_1.3m_Pearl_White__01_6136e3e1-3c72-4cf8-b44c-1d75db58ee2a.jpg?v=1770783457"
          data-image_2="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_XL_1.3m_Space_Grey__01_9ce9bed9-b8de-4517-847c-f3b96b422d66.jpg?v=1770783471"
          data-url_1="/products/prism-solaris-xl?variant=47432039170275"
          data-url_2="/products/prism-solaris-xl?variant=47432039203043"
          data-price="$569.00"
        >
          1.3m
        </span>
      </li>
    </ul>
    `;
    colorlist_solaris.after(template_solaris);


    // solaris pro
    const colorlist_solarisPro = solarisPro.find(".colorlist").first();
    const template_solarisPro = `
    <ul class="collection variantlist colorlist active">
      <li class="variant-item">
        <span
          class="variant-color solaris-size selected"
          data-size="standard"
          data-title="1.0m Rack"
          data-image_1="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Standard_Pro_1.0m_Pearl_White__01_b8962ce0-57fd-4a1d-8c2b-3f27b29acea0.jpg?v=1770865739"
          data-image_2="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_Standard_1.0m_Space_Grey__01_593ac57a-c6c5-4c55-86f8-67c85b374e1f.jpg?v=1770865739"
          data-url_1="/products/prism-solaris-pro?variant=47432042807523"
          data-url_2="/products/prism-solaris-pro?variant=47432042840291"
          data-price="$699.00"
        >
          1.0m
        </span>
      </li>
      <li class="variant-item">
        <span
          class="variant-color solaris-size"
          data-size="xl"
          data-title="1.3m Rack"
          data-image_1="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_XL_1.3m_Pearl_White__01_6136e3e1-3c72-4cf8-b44c-1d75db58ee2a.jpg?v=1770783457"
          data-image_2="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_XL_1.3m_Space_Grey__01_9ce9bed9-b8de-4517-847c-f3b96b422d66.jpg?v=1770783471"
          data-url_1="/products/prism-solaris-pro-xl?variant=47432048574691"
          data-url_2="/products/prism-solaris-pro-xl?variant=47432048607459"
          data-price="$899.00"
        >
          1.3m
        </span>
      </li>
    </ul>
    `;
    colorlist_solarisPro.after(template_solarisPro);

  }

  function addEventListeners() {
    $(".variantlist li span.solaris-size").on("click", function () {
      $(this).closest(".variantlist").find("li span").removeClass("selected");
      $(this).addClass("selected");

      const item = $(this).closest(".grid-view-item");

      //item.find(".pro_grid_desc").text($(this).attr("data-title"));

      const colorlist = item.find(".colorlist").first();
      colorlist
        .find(".variant-item:nth-child(1) span")
        .attr("data-image", $(this).attr("data-image_1"));
      colorlist
        .find(".variant-item:nth-child(2) span")
        .attr("data-image", $(this).attr("data-image_2"));
      colorlist
        .find(".variant-item:nth-child(1) span")
        .attr("data-url", $(this).attr("data-url_1"));
      colorlist
        .find(".variant-item:nth-child(2) span")
        .attr("data-url", $(this).attr("data-url_2"));
      colorlist
        .find(".variant-item:nth-child(1) span")
        .attr("data-price", $(this).attr("data-price"));
      colorlist
        .find(".variant-item:nth-child(2) span")
        .attr("data-price", $(this).attr("data-price"));

      colorlist.find(".variant-item span.selected").click();
      setTimeout(() => {
        colorlist.find(".variant-item span.selected").click();
      }, 0);
    });
  }

  addSizeSelectors();
  addEventListeners();
})();
